// Goal frame material — team-colored emissive neon box around each goal
// mouth. One material instance per goal (only two), so the team color and
// the goal-flash FX uniform are per-instance plain uniforms.

import { uniform } from "three/tsl";
import { Color, MeshBasicNodeMaterial } from "three/webgpu";
import type { BoardsStyle } from "../style/style-schema.js";

function buildUniforms(style: BoardsStyle, team: "home" | "away") {
  return {
    color: uniform(new Color(team === "home" ? style.goal.homeColor : style.goal.awayColor)),
    frameIntensity: uniform(style.goal.frameIntensity),
    /** FX: goal-scored flash, decays toward 0. */
    flash: uniform(0),
  };
}

export type GoalFrameUniforms = ReturnType<typeof buildUniforms>;

export function applyGoalFrameStyle(
  u: GoalFrameUniforms,
  s: BoardsStyle,
  team: "home" | "away",
): void {
  u.color.value.set(team === "home" ? s.goal.homeColor : s.goal.awayColor);
  u.frameIntensity.value = s.goal.frameIntensity;
}

export function createGoalFrameMaterial(
  style: BoardsStyle,
  team: "home" | "away",
): { material: MeshBasicNodeMaterial; u: GoalFrameUniforms } {
  const u = buildUniforms(style, team);

  const material = new MeshBasicNodeMaterial();
  material.colorNode = u.color.mul(u.frameIntensity.mul(u.flash.add(1)));
  return { material, u };
}
